/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIPaginatedPartList,
  APIPart,
  APIPartCreation,
  APIPartCreationRequest,
  APIPartUpdate,
  APIPartUpdateRequest,
  APIPatchedPartUpdateRequest,
} from '../models/index';
import {
    APIPaginatedPartListFromJSON,
    APIPaginatedPartListToJSON,
    APIPartFromJSON,
    APIPartToJSON,
    APIPartCreationFromJSON,
    APIPartCreationToJSON,
    APIPartCreationRequestFromJSON,
    APIPartCreationRequestToJSON,
    APIPartUpdateFromJSON,
    APIPartUpdateToJSON,
    APIPartUpdateRequestFromJSON,
    APIPartUpdateRequestToJSON,
    APIPatchedPartUpdateRequestFromJSON,
    APIPatchedPartUpdateRequestToJSON,
} from '../models/index';

export interface V1RequestRequestsPartsCreateRequest {
    requestPk: string;
    aPIPartCreationRequest: APIPartCreationRequest;
}

export interface V1RequestRequestsPartsDestroyRequest {
    id: string;
    requestPk: string;
}

export interface V1RequestRequestsPartsListRequest {
    requestPk: string;
    page?: number;
    pageSize?: number;
}

export interface V1RequestRequestsPartsPartialUpdateRequest {
    id: string;
    requestPk: string;
    aPIPatchedPartUpdateRequest?: APIPatchedPartUpdateRequest;
}

export interface V1RequestRequestsPartsRetrieveRequest {
    id: string;
    requestPk: string;
}

export interface V1RequestRequestsPartsUpdateRequest {
    id: string;
    requestPk: string;
    aPIPartUpdateRequest: APIPartUpdateRequest;
}

/**
 * 
 */
export class GuestRequestpartApi extends runtime.BaseAPI {

    /**
     * Creates a new Article instance that represents a part of an assembly. Uses article properties to store information like:  - manufacturing process  - part material  - post treatment  - part estimated price
     */
    async v1RequestRequestsPartsCreateRaw(requestParameters: V1RequestRequestsPartsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPartCreation>> {
        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsPartsCreate().'
            );
        }

        if (requestParameters['aPIPartCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIPartCreationRequest',
                'Required parameter "aPIPartCreationRequest" was null or undefined when calling v1RequestRequestsPartsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/parts/`.replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIPartCreationRequestToJSON(requestParameters['aPIPartCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPartCreationFromJSON(jsonValue));
    }

    /**
     * Creates a new Article instance that represents a part of an assembly. Uses article properties to store information like:  - manufacturing process  - part material  - post treatment  - part estimated price
     */
    async v1RequestRequestsPartsCreate(requestParameters: V1RequestRequestsPartsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPartCreation> {
        const response = await this.v1RequestRequestsPartsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * A higher level viewset that is responsible for creating articles that are used to hold information about a part of an assembly.  It creates an abstraction over the article and bom models, as it automatically organizes parts (represented by articles) into a BOM.  Main use case:     Automated quote generation for assemblies / parts found in CAD-files.
     */
    async v1RequestRequestsPartsDestroyRaw(requestParameters: V1RequestRequestsPartsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsPartsDestroy().'
            );
        }

        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsPartsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/parts/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * A higher level viewset that is responsible for creating articles that are used to hold information about a part of an assembly.  It creates an abstraction over the article and bom models, as it automatically organizes parts (represented by articles) into a BOM.  Main use case:     Automated quote generation for assemblies / parts found in CAD-files.
     */
    async v1RequestRequestsPartsDestroy(requestParameters: V1RequestRequestsPartsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1RequestRequestsPartsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * A higher level viewset that is responsible for creating articles that are used to hold information about a part of an assembly.  It creates an abstraction over the article and bom models, as it automatically organizes parts (represented by articles) into a BOM.  Main use case:     Automated quote generation for assemblies / parts found in CAD-files.
     */
    async v1RequestRequestsPartsListRaw(requestParameters: V1RequestRequestsPartsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPaginatedPartList>> {
        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsPartsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/parts/`.replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPaginatedPartListFromJSON(jsonValue));
    }

    /**
     * A higher level viewset that is responsible for creating articles that are used to hold information about a part of an assembly.  It creates an abstraction over the article and bom models, as it automatically organizes parts (represented by articles) into a BOM.  Main use case:     Automated quote generation for assemblies / parts found in CAD-files.
     */
    async v1RequestRequestsPartsList(requestParameters: V1RequestRequestsPartsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPaginatedPartList> {
        const response = await this.v1RequestRequestsPartsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * A higher level viewset that is responsible for creating articles that are used to hold information about a part of an assembly.  It creates an abstraction over the article and bom models, as it automatically organizes parts (represented by articles) into a BOM.  Main use case:     Automated quote generation for assemblies / parts found in CAD-files.
     */
    async v1RequestRequestsPartsPartialUpdateRaw(requestParameters: V1RequestRequestsPartsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPartUpdate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsPartsPartialUpdate().'
            );
        }

        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsPartsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/parts/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedPartUpdateRequestToJSON(requestParameters['aPIPatchedPartUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPartUpdateFromJSON(jsonValue));
    }

    /**
     * A higher level viewset that is responsible for creating articles that are used to hold information about a part of an assembly.  It creates an abstraction over the article and bom models, as it automatically organizes parts (represented by articles) into a BOM.  Main use case:     Automated quote generation for assemblies / parts found in CAD-files.
     */
    async v1RequestRequestsPartsPartialUpdate(requestParameters: V1RequestRequestsPartsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPartUpdate> {
        const response = await this.v1RequestRequestsPartsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * A higher level viewset that is responsible for creating articles that are used to hold information about a part of an assembly.  It creates an abstraction over the article and bom models, as it automatically organizes parts (represented by articles) into a BOM.  Main use case:     Automated quote generation for assemblies / parts found in CAD-files.
     */
    async v1RequestRequestsPartsRetrieveRaw(requestParameters: V1RequestRequestsPartsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPart>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsPartsRetrieve().'
            );
        }

        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsPartsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/parts/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPartFromJSON(jsonValue));
    }

    /**
     * A higher level viewset that is responsible for creating articles that are used to hold information about a part of an assembly.  It creates an abstraction over the article and bom models, as it automatically organizes parts (represented by articles) into a BOM.  Main use case:     Automated quote generation for assemblies / parts found in CAD-files.
     */
    async v1RequestRequestsPartsRetrieve(requestParameters: V1RequestRequestsPartsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPart> {
        const response = await this.v1RequestRequestsPartsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the properties of a Part. These are:  - manufacturing process  - material  - post treatment  - quality class  - technical_drawing Price recalculation is triggered via the dedicated recalculate action.
     */
    async v1RequestRequestsPartsUpdateRaw(requestParameters: V1RequestRequestsPartsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPartUpdate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsPartsUpdate().'
            );
        }

        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsPartsUpdate().'
            );
        }

        if (requestParameters['aPIPartUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIPartUpdateRequest',
                'Required parameter "aPIPartUpdateRequest" was null or undefined when calling v1RequestRequestsPartsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/parts/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: APIPartUpdateRequestToJSON(requestParameters['aPIPartUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPartUpdateFromJSON(jsonValue));
    }

    /**
     * Updates the properties of a Part. These are:  - manufacturing process  - material  - post treatment  - quality class  - technical_drawing Price recalculation is triggered via the dedicated recalculate action.
     */
    async v1RequestRequestsPartsUpdate(requestParameters: V1RequestRequestsPartsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPartUpdate> {
        const response = await this.v1RequestRequestsPartsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
